/**
 * Midpoint of min/max budget for summary lines (defaults match Firestore-less UI).
 */
export function getBudgetMidpointDollars(giftee) {
  const min =
    typeof giftee?.budgetMin === "number" ? giftee.budgetMin : 50;
  const max =
    typeof giftee?.budgetMax === "number" ? giftee.budgetMax : 120;
  return Math.round((min + max) / 2);
}
